import { useState, useEffect } from 'react';
import { trackEvent } from '../../utils/analytics';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import AlertBanner from './components/AlertBanner';
import WhyAccountant from './components/WhyAccountant';
import TrifectaDefense from './components/TrifectaDefense';
import Testimonial from './components/Testimonial';
import BinaryChoice from './components/BinaryChoice';
import CalendarSection from './components/CalendarSection';
import YouTubeBridge from './components/YouTubeBridge';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import StickyCtaBar from './components/StickyCtaBar';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemas = [
  {
    id: 'schema-website',
    data: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: "Protect What's Mine",
      url: SITE_URL,
      description:
        'Asset Protection, Tax Strategy, Entity Structuring, and Estate Planning curated by Matt Theriault and executed by KKOS Lawyers.',
    },
  },
  {
    id: 'schema-legalservice',
    data: {
      '@context': 'https://schema.org',
      '@type': 'LegalService',
      name: 'KKOS Lawyers — Trifecta Defense System',
      url: SITE_URL,
      description:
        'Comprehensive legal protection combining Entity Structuring, Tax Strategy, and Estate Planning for real estate investors and high-net-worth individuals.',
      serviceType: [
        'Asset Protection',
        'Tax Strategy',
        'Entity Structuring',
        'Estate Planning',
      ],
      provider: {
        '@type': 'Organization',
        name: 'KKOS Lawyers',
        url: 'https://kkoslawyers.com',
      },
    },
  },
  {
    id: 'schema-faq',
    data: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What is the Trifecta Defense System for real estate investors?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'The Trifecta Defense System is a comprehensive legal plan that combines Entity Structuring (LLCs and S-Corps), Tax Strategy to minimize liabilities, and Estate Planning to bypass probate. It is executed by KKOS Lawyers.',
          },
        },
        {
          '@type': 'Question',
          name: 'Why do I need a tax attorney instead of just a CPA?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: "Most accountants act as historians who just record what you owe. A tax attorney acts as a strategist to build legal walls around your assets, preventing lawsuits and aggressively legally reducing your tax burden.",
          },
        },
        {
          '@type': 'Question',
          name: 'How do I protect my personal assets from business liability?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: "You must establish the 'Entity Gap' by using proper business entity formation, such as an LLC or S-Corp, to separate your personal assets from your business income and real estate holdings.",
          },
        },
      ],
    },
  },
];

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    trackEvent('page_view');
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    schemas.forEach(({ id, data }) => {
      if (!document.getElementById(id)) {
        const script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(data);
        document.head.appendChild(script);
      }
    });
    return () => {
      schemas.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  return (
    <div className="bg-[#0a0a0a] text-white">
      <Navbar isScrolled={isScrolled} />
      <AlertBanner />
      <Hero />
      <TrustBar />
      <Testimonial />
      <WhyAccountant />
      <TrifectaDefense />
      <BinaryChoice />
      <YouTubeBridge />
      <CalendarSection />
      <Footer />
      <StickyCtaBar />
    </div>
  );
}
